import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import AddIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from "@material-ui/core/Tooltip";
import { withSnackbar } from "notistack";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,

  },

});

const FloatingActionButtons = (props) => {
  const { classes, InActive, selectedSubscription } = props;
  module = props.data;

  const checkModule = () => {
    if (InActive && InActive.length != 0) {
      props.enqueueSnackbar(`${InActive && InActive[0] && InActive[0].subscriptionname} is already pending activation`, { variant: "error" });
      return;
    }
    if (module == "dashboard") {
      window.open("/newsubscription", "_self");
      // props.history.push('/newsubscription');
    }
    if (module == "subscriptionowner"/* && InActive && InActive.length == 0 */) {
      // props.history.push('/subscriptionowner/new');
      window.open('/subscriptionowner/new', "_self");
    }
    if (module == "superuser") {
      props.history.push('./addnewlead');
    }
    if (module == "superuserview") {
      props.history.push('../addnewlead');
    }
    if (module == "superuserlist") {
      props.history.push('./addnewsuperuser');
    }
  };
  return (
    <div>
      {props.tooltip ? (<Tooltip title={props.tooltip == "Add new company" ? "" : props.tooltip} placement="left">
        {props.nobutton
        ? <span onClick={() => checkModule()} style={{ fontWeight: "bold", color: "#057cff", cursor: "pointer" }}>+ </span>
        : <span><Button
          variant="fab"
          color="primary"
          aria-label="Add"
          onClick={() => checkModule()}
        >
          <AddIcon />
        </Button></span>}
        </Tooltip>) : (<Button
        variant="fab"
        color="primary"
        aria-label="Add"
        className={classes.button} onClick={() => checkModule()}
      >
        <AddIcon />
      </Button>)}
    </div>
  );
};

FloatingActionButtons.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(withSnackbar(FloatingActionButtons));
